/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React, { useEffect, useState } from 'react';
import {
  CarricomComp,
  ProgressBar,
  SelectComp,
  WorkPermitComp,
  Header,
  AppCardListComp,
  UsersListComp,
  SelectSubmissionType,
  draftDataNotPresent,
  draftDataIsPresent,
  RenewCsmeComp,
  CsmeComp,
  RenewWorkPermitComp,
  SelectComp1,
  RightEstablishmentForm,
  MarriageExemptionComp,
  RightEstablishmentEmployerForm,
} from '../components';
import { useTheme } from '../../../providers/theme';
import { vappContainer, VApplication } from '../../../application';
import { useNavigate, useLocation } from 'react-router-dom';
import { Acknowledgement } from '../components/Acknowledgement';
import {
  useSMNewApplicationPage,
  useSMCarricomAppPage,
  useSMGetDraftedApp,
  useSMInviteUser,
  useSMSaveApplicantAppPage,
  useSMCanCreateNewAppContent,
  useSMResubmitApplicationPage,
  useSMWorkPermitDraftPage,
  useSMroeworkPermitDraftPage,
} from '../machines';
import { ApplicationFormPageService } from '../services';
import { StateOSD } from '@vlinder-web/state-osd-v2-widget-react';
import { toast } from 'react-hot-toast';
import { useViewport } from '@vlinder-web/viewport-provider-react';
import { StorageModule } from '@vlinder-web/storage-module-react';
import { AppNavigatorService } from '@/AppNavigator';
import _, { initial, last } from 'lodash';
import { TweetyModal } from '@vlinder-web/tweety-modal-widget-react';
import { USER_LEVEL } from '@/config/userManagement.config';
import RouteConfig from '@/AppNavigator/services/config/routes.config.json';
import { logger as log } from '@common/logger';
import humanizeString from 'humanize-string';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import { useApplication } from '../services/provider';
// import {} from '../components/'
import { NotificationModal } from '@vlinder-web/notification-modal-v2-widget-react';
import { Loader } from '@/components';
import { RenewMarriageExemptionComp } from '../components/RenewMarriageExemption';
import { useSMresubmitApplicationByApplicantPage } from '../machines/resubmitapplicant';
import { RoeWPForm } from '../components/RoeWPForm';
import { RoeRWPForm } from '../components/RowRWPForm';
import { useSMGetTypeOfApplication } from '../machines/getTypeOfApplication';
import { useSMGetParishAndCityGetContent } from '../machines/getParishAndCity';

const getSrv = () => {
  return vappContainer.get<ApplicationFormPageService>(
    ApplicationFormPageService.displayName
  );
};

const getAppSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export const ContainerComm = (props: any) => {
  const theme = useTheme();
  const srv = getSrv();
  const { applicationNo: providerApplicationNo } = useApplication();
  const navigate = useNavigate();
  const appSrv = getAppSrv();
  const { state } = useLocation();
  const storageService = StorageModule.getInstance();
  const userProfile = storageService.get('myProfile', 'session');
  const role = userProfile?.org?.orgRole;
  // const formDataConfig = getSrv()?.agent.getFormData();
  const [roe, setRoe] = useState(false);
  useEffect(() => {
    if (role === 'CARICOM_BUSSINESS_ORG') setRoe(true);
  }, [role]);
  const [touched, setTouched] = useState<any>({});
  const [stepHasError, setStepHasError] = useState<any>({});
  const [employeeAppliesApplicant, setemployeeAppliesApplicant] =
    useState(false);
  const [implicitSave, setImplicitSave] = useState(false);
  const [proceedToInvite, setproceedToInvite] = useState(false);
  const { height } = useViewport();
  const [showModal, setShowModal] = useState<boolean>(false);
  const [activeStep, setActiveStep] = useState(0);
  const [currentStep, setCurrentStep] = useState(0);
  const [vuid, setVuid] = useState();
  const [mainStep, setMainStep] = useState(0);
  const [roestep, setroestep] = useState(1);
  const [savebtn, setsavebtn] = useState(false);
  const [initialData, setInitialData] = useState<any>({
    jamaicanProfessional: '0',
    jamaicanClerks: '0',
    jamaicanSkilledWorkers: '0',
    jamaicanPlant: '0',
    jamaicanElementary: '0',
    carricomProfessional: '0',
    carricomClerks: '0',
    carricomSkilledWorkers: '0',
    carricomPlant: '0',
    carricomElementary: '0',
    commonWealthProfessional: '0',
    commonWealthClerks: '0',
    commonWealthSkilledWorkers: '0',
    commonWealthPlant: '0',
    commonWealthElementary: '0',
    foreignProfessional: '0',
    foreignClerks: '0',
    foreignSkilledWorkers: '0',
    foreignPlant: '0',
    foreignElementary: '0',
  });

  console.log(`currentStep :: #1`, currentStep);
  const SwalWithBootstrapButtons = withReactContent(
    Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-primary me-3',
        cancelButton: 'btn btn-secondary',
      },
      buttonsStyling: false,
    })
  );

  const [applicationNo, setApplicationNo] = useState('');
  // const [inbuiltData, setInbuiltData] = useState({});
  const [selectForm, setselectForm] = useState('');
  const [spinner, setSpinner] = useState({
    show: false,
    status: 'loading',
  });
  const [whoAmI, setWhoAmI] = useState('');
  const [draftData, setDraftData] = useState({
    exist: true,
    data: {},
  });
  const { canCreateNewAppSend, canCreateNewAppState } =
    useSMCanCreateNewAppContent({});
  const {
    getParishAndCityMachine,
    getParishAndCitySend,
    getParishAndCityState,
  } = useSMGetParishAndCityGetContent({});

  const staticPageContentConfig = srv.agent.getStaticPageContentSync({});
  const { getDraftedAppSend, getDraftedAppState } = useSMGetDraftedApp({});
  const { newApplicationPageSend, newApplicationPageState } =
    useSMNewApplicationPage({});
  const {
    resubmitApplicationPageMachine,
    resubmitApplicationPageSend,
    resubmitApplicationPageState,
  } = useSMResubmitApplicationPage({});
  const {
    resubmitApplicationByApplicantPageMachine,
    resubmitApplicationByApplicantPageSend,
    resubmitApplicationByApplicantPageState,
  } = useSMresubmitApplicationByApplicantPage({});
  const { saveApplicantAppPageSend, saveApplicantAppPageState } =
    useSMSaveApplicantAppPage({});
  const { workPermitDraftPageSend, workPermitDraftPageState } =
    useSMWorkPermitDraftPage({});
  const {
    roeworkPermitDraftPageMachine,
    roeworkPermitDraftPageSend,
    roeworkPermitDraftPageState,
  } = useSMroeworkPermitDraftPage({});
  const { carricomAppPageSend, carricomAppPageState } = useSMCarricomAppPage(
    {}
  );
  const { inviteUserMachine, inviteUserSend, inviteUserState } =
    useSMInviteUser({});

  const { getTypeOfApplicationPageSend, getTypeOfApplicationPageState } =
    useSMGetTypeOfApplication({});
  const [fontScale, setFontScale] = useState(
    storageService.get('fontScale', 'session') ?? 0
  );
  const updateFontScale = (font: any) => {
    setFontScale(font);
    storageService.set('fontScale', font, 'session');
  };
  console.log('font->', fontScale);
  const {
    workPermitFormData,
    renewWorkPermitFormData,
    csmeFormData,
    marriageFormData,
    acknowledgement,
    csmeVerificationFormData,
    renewCsmeFormData,
    rightEstablishmentContent,
    marriageExemptionFormData,
    resubmitFormData,
    applicationCards,
    roeworkPermitFormData,
  } = staticPageContentConfig;
  const [clicked, setClicked] = useState('');

  console.log('step->has', stepHasError);

  const onGoBack = () => {
    console.log('dat=>activestep-->gobackcalled');
    setMainStep(mainStep - 1);
    setroestep(roestep - 1);
  };
  // useEffect(()=>console.log("dat=>activestep---mainstep",mainStep))
  useEffect(() => {
    getWhoamI();
    if (
      // state?.data?.status !== 'APPLICATION_INCOMPLETE' &&
      // state?.data?.status !== 'APPLICANT_DRAFT' &&
      // !getDraftedAppState?.matches('RENDER_DRAFTED_APP') &&
      // !getDraftedAppState?.event?.data?.value
      !providerApplicationNo
    ) {
      const _draftId = storageService.get('DRAFT_APP_ID', 'session');
      if (_draftId) {
        storageService.remove('DRAFT_APP_ID', 'session');
      }
      const _localData = storageService.get('myProfile', 'local');
      const _sessionData = storageService.get('myProfile', 'session');
      const data = _sessionData ?? _localData;
      const _whoAmI =
        data?.role && Array.isArray(data?.role) && data?.role[0]?.name;

      if (data?.email && _whoAmI !== 'prospective_employee') {
        setInitialData({
          ...initialData,
          ...draftDataNotPresent(data),
        });
      } else if (data?.email && _whoAmI === 'prospective_employee') {
        console.log('imcomingforyou....->1->');

        setInitialData({
          ...initialData,
          firstName: data?.firstName,
          lastName: data?.lastName,
          userEmail: data?.email,
          trn: data?.trn,
        });
      }
    }
  }, []);

  const updateOccupationList = async () => {
    const occupationList = await getSrv().agent.getOccupationList();
    console.log('inip->response---demochck-->', occupationList);
    setInitialData({
      ...initialData,
      occupationList: occupationList?.data ?? [],
    });
  };
  useEffect(() => {
    if (whoAmI === 'prospective_employee' && selectForm !== '') {
      // canCreateNewAppSend("START",{
      //   payload:{
      //     type:selectForm,
      //     email:initialData?.userEmail
      //   }
      // })
    }
    console.log('reach->', selectForm);
    if (
      !initialData?.occupationList &&
      (selectForm === 'RENEW_WORK_PERMIT' || selectForm === 'NEW_WORK_PERMIT')
    ) {
      console.log('reach->');
      updateOccupationList();
    }
  }, [selectForm]);

  console.log('inip->', initialData);

  useEffect(() => {
    console.log(
      getDraftedAppState?.matches('RENDER_DRAFTED_APP'),
      getDraftedAppState,
      'lp->'
    );
    if (
      providerApplicationNo &&
      getDraftedAppState?.matches('RENDER_DRAFTED_APP') &&
      getDraftedAppState?.event?.data?.value
    ) {
      console.log(
        `APPLICATION_INCOMPLETE #1 :`,
        getDraftedAppState?.event?.data?.value
      );
      setMainStep(mainStep + 1);
      setClicked(getDraftedAppState?.event?.data?.value?.applicationNo);
      setApplicationNo(getDraftedAppState?.event?.data?.value?.applicationNo);
      if (
        getDraftedAppState?.event?.data?.value?.type ===
        'NEW_RIGHTS_OF_ESTABLISHMENT'
      )
        setselectForm('NEW_WORK_PERMIT');
      else setselectForm(getDraftedAppState?.event?.data?.value?.type);
      const _draftData = getDraftedAppState?.event?.data?.value;
      console.log('poi->', initialData, _draftData);
      // setselectForm(_draftData?.type);
      if (_draftData) {
        setDraftData({
          exist: true,
          data: _draftData,
        });
      }

      const _localData = storageService.get('myProfile', 'local');
      const _sessionData = storageService.get('myProfile', 'session');
      const data = _sessionData ?? _localData;
      const _whoAmI =
        data?.role && Array.isArray(data?.role) && data?.role[0]?.name;
      if (data?.email && _whoAmI !== 'prospective_employee') {
        setInitialData({
          ...initialData,
          ..._draftData,
          // ...draftDataIsPresent(data),
        });
      } else if (data?.email && _whoAmI === 'prospective_employee') {
        console.log('imcomingforyou....->2->', _draftData);

        setInitialData({
          ...initialData,
          firstName: data?.firstName,
          lastName: data?.lastName,
          trn: data?.businessTrn,
          ..._draftData,
        });
      }
    }
  }, [
    getDraftedAppState?.matches('RENDER_DRAFTED_APP') &&
      getDraftedAppState?.event?.data?.value,
  ]);
  useEffect(() => {
    if (
      newApplicationPageState.matches('CREATE_APPLICATION_ERROR') &&
      newApplicationPageState?.event?.data?.value
    ) {
      toast.error(
        newApplicationPageState?.event?.data?.value ?? 'Something went wrong'
      );
    }
  }, [
    newApplicationPageState.matches('CREATE_APPLICATION_ERROR') &&
      newApplicationPageState?.event?.data?.value,
  ]);
  useEffect(() => {
    if (saveApplicantAppPageState.matches('CREATE_APPLICATION_ERROR')) {
      toast.error(
        saveApplicantAppPageState?.event?.data?.value ?? 'Something went wrong'
      );
    }
  }, [
    saveApplicantAppPageState.matches('CREATE_APPLICATION_ERROR'),
    saveApplicantAppPageState?.event?.data?.value,
  ]);
  useEffect(() => {
    if (
      inviteUserState?.matches('INVITE_USER_SUCCESS') &&
      inviteUserState?.event?.data?.value
    ) {
      const _vuid = inviteUserState?.event?.data?.value?.vuid;
      setVuid(inviteUserState?.event?.data?.value?.vuid);
      const _draftId = storageService.get('DRAFT_APP_ID', 'session');
      const lastApplicantId = storageService.get('LAST_DRAFT_APP', 'session');
      const lastApplicationId = storageService.get(
        'LAST_DRAFT_APP_ID',
        'session'
      );
      console.log('lopi->', initialData?.applicant, _vuid);
      // if (!initialData?.applicant || initialData?.applicant !== _vuid) {
      console.log('lopi->', initialData?.applicant, _vuid);
      setInitialData({ ...initialData, applicant: _vuid });
      if (applicationNo) {
        canCreateNewAppSend('START', {
          payload: {
            type: selectForm,
            applicant: _vuid,
            applicationNo: applicationNo,
          },
        });
      } else {
        canCreateNewAppSend('START', {
          payload: {
            type: selectForm,
            applicant: _vuid,
          },
        });
      }
      // }
    }
  }, [
    inviteUserState?.matches('INVITE_USER_SUCCESS') &&
      inviteUserState?.event?.data?.value,
  ]);

  useEffect(() => {
    if (
      canCreateNewAppState?.matches('CAN_CREATE_ERROR') &&
      canCreateNewAppState?.event?.data?.value
    ) {
      if (
        selectForm !== 'CSME_VERIFICATION' &&
        selectForm !== 'NEW_CSME_CERTIFICATE'
      ) {
        if (canCreateNewAppState?.event?.data?.value?.message) {
          toast.error(canCreateNewAppState?.event?.data?.value?.message);
        }
        if (!USER_LEVEL.owner.includes(whoAmI)) {
          setselectForm('');
          getWhoamI();
          setClicked('');
          setMainStep(0);
        } else {
          setCurrentStep(currentStep - 1);
        }
      }
    }
  }, [
    canCreateNewAppState?.matches('CAN_CREATE_ERROR') &&
      canCreateNewAppState?.event?.data?.value,
  ]);

  console.log('lop->', currentStep, mainStep);

  useEffect(() => {
    if (
      inviteUserState?.matches('INVITE_USER_FAILED') &&
      inviteUserState?.event?.data?.value
    ) {
      setCurrentStep(currentStep - 1);
    }
  }, [
    inviteUserState?.matches('INVITE_USER_FAILED') &&
      inviteUserState?.event?.data?.value,
  ]);

  const _onNewWorkPermitNext = (formData: any) => {
    getSrv().setNewWorkPermitData(formData);
  };
  const onResubmitApp = (data: any, type: string) => {
    // toast.success("missing info submit");
    resubmitApplicationPageSend('MUTATE', {
      payload: {
        ...data,
        type,
        applicant: vuid,
        fillApplicantInfo: employeeAppliesApplicant,
      },
    });
  };
  const onResubmitApplicant = (data: any, type: string) => {
    // toast.success("missing info submit");
    resubmitApplicationByApplicantPageSend('MUTATE', {
      payload: {
        ...data,
        // type,
        applicant: vuid,
        fillApplicantInfo: employeeAppliesApplicant,
      },
    });
  };
  const onWorkPermitSubmit = (data: any, type: string) => {
    console.log(`onWorkPermitSubmit in ContainerCom : ${type}`, vuid, data);
    if (type === 'NEW_WORK_PERMIT' || type === 'RENEW_WORK_PERMIT') {
      if (!spinner?.show) {
        setSpinner({
          show: true,
          status: 'loading',
        });
      }
      newApplicationPageSend('MUTATE', {
        payload: {
          ...data,
          type,
          applicant: vuid,
          fillApplicantInfo: employeeAppliesApplicant,
        },
      });
    }
  };
  const onRoeWorkPermitSubmit = (data: any, type: string) => {
    console.log(
      `onWorkPermitSubmit in ContainerCom in acknowlefgment: ${type}`,
      employeeAppliesApplicant
    );
    // if (type === 'NEW_WORK_PERMIT' || type === 'RENEW_WORK_PERMIT') {
    if (!spinner?.show) {
      console.log('jraminroespinnerfind-->submit');
      setSpinner({
        show: true,
        status: 'loading',
      });
    }
    roeworkPermitDraftPageSend('MUTATE', {
      payload: {
        ...data,
        type: type,
        applicant: vuid,
        fillApplicantInfo: employeeAppliesApplicant,
        submit: true,
      },
    });
  };
  const onRoeWorkPermitNext = (data: any, save: any = false) => {
    // savebtn=!save;
    console.log(`onWorkPermitSubmit in ContainerCom : `, vuid, data);
    // if (type === 'NEW_WORK_PERMIT' || type === 'RENEW_WORK_PERMIT') {
    // if (save && !spinner?.show) {
    //   console.log('jraminroespinnerfind-->next');
    //   setSpinner({
    //     show: true,
    //     status: 'loading',
    //   });
    // }
    setImplicitSave(!save);
    roeworkPermitDraftPageSend('MUTATE', {
      payload: {
        ...data,
        applicant: vuid,
        fillApplicantInfo: employeeAppliesApplicant,
        implicitSave: !save,
        submit: false,
      },
    });
  };
  const onCSMESubmit = (data: any, type: string) => {
    console.log(`onCSMESubmit in ContainerCom : ${type}`, vuid, data);
    if (
      type === 'NEW_CSME_CERTIFICATE' ||
      type === 'RENEW_CSME_CERTIFICATE' ||
      type === 'CSME_VERIFICATION'
    ) {
      if (!spinner?.show) {
        setSpinner({
          show: true,
          status: 'loading',
        });
      }
      saveApplicantAppPageSend('MUTATE', {
        payload: {
          ...data,
          type,
          applicant: vuid,
          submit: true,
        },
      });
    }
  };

  const onMarriageExemSubmit = (data: any, type: string) => {
    console.log(`onMarriageExemSubmit in ContainerCom : ${type}`, vuid, data);
    if (type === 'MARRIAGE_EXEMPTION' || type === 'RENEW_MARRIAGE_EXEMPTION') {
      if (!spinner?.show) {
        setSpinner({
          show: true,
          status: 'loading',
        });
      }
      saveApplicantAppPageSend('MUTATE', {
        payload: {
          ...data,
          type,
          applicant: vuid,
          submit: true,
        },
      });
    }
  };

  const onROEemployerSubmit = (data: any, type: string) => {
    console.log(`onROEemployerSubmit in ContainerCom : ${type}`, vuid, data);
    toast.success('comingsoon');
    // if (type === 'MARRIAGE_EXEMPTION') {
    //   saveApplicantAppPageSend('MUTATE', {
    //     payload: {
    //       ...data,
    //       type,
    //       applicant: vuid,
    //       submit: true,
    //     },
    //   });
    // }
  };

  const onUserDetailsSubmit = (data: any) => {
    const _sessionData = storageService.get('myProfile', 'session');
    const _localData = storageService.get('myProfile', 'local');

    const userData = _sessionData ?? _localData;

    const _vuid = vuid
      ? vuid
      : userData && userData?.vuid
      ? userData?.vuid
      : null;
    // canCreateNewAppSend('START', {
    //   payload: {
    //     type: selectForm,
    //     applicant: _vuid,
    //   },
    // });
    inviteUserSend('START', {
      payload: data,
    });
  };

  const _onDraftSave = (data: any, type: string, implicitSave?: boolean) => {
    console.log(`_onDraftSave :: formData : `, draftData?.data, data);
    const storageService = StorageModule.getInstance();
    const _localData = storageService.get('myProfile', 'local');
    const _sessionData = storageService.get('myProfile', 'session');
    const userData = _sessionData ?? _localData;
    const _vuid = vuid
      ? { applicant: vuid }
      : userData && userData?.vuid && !USER_LEVEL.owner.includes(whoAmI)
      ? { applicant: userData?.vuid }
      : {};
    setImplicitSave(implicitSave ?? false);
    workPermitDraftPageSend('MUTATE', {
      payload: {
        ...draftData?.data,
        ...data,
        ..._vuid,
        implicitSave,
        applicationType: type,
        fillApplicantInfo: employeeAppliesApplicant,
      },
    });
  };

  const _onCSMEDraftSave = (
    data: any,
    type: string,
    implicitSave?: boolean
  ) => {
    console.log(
      `_onDraftSave :: formData : _onCSMEDraftSave `,
      type,
      data?.expEmail,
      data?.userEmail
    );
    const storageService = StorageModule.getInstance();
    const _localData = storageService.get('myProfile', 'local');
    const _sessionData = storageService.get('myProfile', 'session');
    const userData = _sessionData ?? _localData;
    const _vuid = vuid
      ? { applicant: vuid }
      : userData && userData?.vuid
      ? { applicant: userData?.vuid }
      : {};
    setImplicitSave(implicitSave ?? false);
    if (
      ((type === 'MARRIAGE_EXEMPTION' || type === 'RENEW_MARRIAGE_EXEMPTION') &&
        data?.expEmail &&
        data?.userEmail) ||
      (type === 'NEW_CSME_CERTIFICATE' && data?.userEmail) ||
      (type === 'CSME_VERIFICATION' && data?.userEmail)
    ) {
      saveApplicantAppPageSend('MUTATE', {
        payload: {
          ...draftData?.data,
          ...data,
          ..._vuid,
          submit: false,
          implicitSave: implicitSave ?? false,
          type: type,
        },
      });
    } else {
      toast.error('To save an application, an email address is required');
    }
  };

  useEffect(() => {
    console.log('getDraftedAppState?.matches', getDraftedAppState);
    if (getDraftedAppState?.matches('RENDER_DRAFTED_APP_ERROR')) {
      toast.error(getDraftedAppState?.event?.data?.value ?? '');
      setTimeout(() => {
        navigate('/draft-applications');
      }, 1000);
    }
  }, [getDraftedAppState?.matches('RENDER_DRAFTED_APP_ERROR')]);

  useEffect(() => {
    console.log('ent->', providerApplicationNo);
    if (providerApplicationNo) {
      console.log('ent->');
      getDraftedAppSend('START', {});
    }
  }, [providerApplicationNo]);

  console.log('pod->', getDraftedAppState?.value);

  const onFormSubmit = (data: any) => {
    setInitialData({ ...data });
  };
  const [subStep, setSubStep] = useState(0);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [activeStep, subStep]);

  useEffect(() => {
    setSubStep(0);
  }, [activeStep]);
  const [citydata, setCitydata] = useState<any>({});
  useEffect(() => {
    if (getParishAndCityState?.matches('RENDER_PAGE')) {
      setCitydata(getParishAndCityState?.event?.data?.value?.data);
    }
  }, [getParishAndCityState]);
  const getWhoamI = async () => {
    const { whoami } = await appSrv.whoAmI();
    setWhoAmI(whoami);
    if (USER_LEVEL.owner.includes(whoami ?? '')) {
      setCurrentStep(1);
    } else {
      setCurrentStep(0);
    }
  };

  useEffect(() => {
    if (
      USER_LEVEL.employee.includes(whoAmI ?? '') &&
      selectForm !== 'RIGHTS_OF_ESTABLISHMENT'
      //  &&     selectForm !== 'MARRIAGE_EXEMPTION'
    ) {
      const _draftId = storageService.get('DRAFT_APP_ID', 'session');
      const _localData = storageService.get('myProfile', 'local');
      const _sessionData = storageService.get('myProfile', 'session');
      const userData = _sessionData ?? _localData;

      const _vuid = vuid
        ? vuid
        : userData && userData?.vuid
        ? userData?.vuid
        : null;
      console.log('pou->', initialData?.applicant, _vuid);
      if (
        selectForm &&
        (!initialData?.applicant || initialData?.applicant !== _vuid)
      ) {
        setInitialData({ ...initialData, applicant: _vuid });
        canCreateNewAppSend('START', {
          payload: {
            type: selectForm,
            applicant: _vuid,
          },
        });
      }
    }
  }, [whoAmI, selectForm, vuid]);

  const onCloseClick = () => {
    console.log(`selectForm :: #1`, selectForm);
    if (initialData && initialData?.status === 'MISSING_INFORMATION') {
      navigate('/missing-info');
      return;
    }
    if (spinner?.status === 'success') {
      setInitialData({});
      setApplicationNo('');
      window.open('/application-form', '_self');
      return;
    }
    if (selectForm === 'RENEW_WORK_PERMIT') {
      confirmClose(() => {
        navigate(-1);
        // setMainStep(0);
        // setCurrentStep(1);
        // if (whoAmI === 'prospective_employee' && clicked) {
        //   setClicked('');
        // }
      });
    } else {
      window.open('/application-form', '_self');
      setMainStep(0);
      setCurrentStep(1);

      if (whoAmI === 'prospective_employee' && clicked) {
        setClicked('');
      }
    }
  };

  const changeStep = (step: number, existingFormData: any) => {
    console.log('dat=>activestep--container', step);
    setCurrentStep(Math.max(step, currentStep + 1));
    console.log('dat->', existingFormData);
    setInitialData(existingFormData);
  };

  const onApplicantSelectChange = (val: any) => {
    storageService.remove('DRAFT_APP_ID', 'session');
    if (val === 'NEW_CSME_CERTIFICATE') {
      setClicked('NCSME');
      setselectForm(val);
      setMainStep(mainStep + 1);
    } else if (val === 'CSME_VERIFICATION') {
      setClicked('NCSME');
      setselectForm(val);
      setMainStep(mainStep + 1);
    } else if (val === 'RIGHTS_OF_ESTABLISHMENT') {
      setClicked('NCSME');
      setselectForm(val);
      setMainStep(mainStep + 1);
    } else if (val === 'RENEW_CSME_CERTIFICATE') {
      setClicked('RCSME');
      setselectForm('RENEW_CSME_CERTIFICATE');
      setMainStep(mainStep + 1);
    } else if (val === 'MARRIAGE_EXEMPTION') {
      setClicked('MEXEM');
      setselectForm('MARRIAGE_EXEMPTION');
      setMainStep(mainStep + 1);
    } else if (val === 'RENEW_MARRIAGE_EXEMPTION') {
      setClicked('MEXEM');
      setselectForm('RENEW_MARRIAGE_EXEMPTION');
      setMainStep(mainStep + 1);
    } else {
      navigate(-1);
    }
  };

  const onChangeForm = (val: any) => {
    storageService.remove('DRAFT_APP_ID', 'session');
    if (val === 'RENEW_WORK_PERMIT') {
      navigate('/work-permits');
    }
    setMainStep(mainStep + 1);
    if (val === 'NEW_WORK_PERMIT' && roe)
      setselectForm('CARICOM_NEW_WORK_PERMIT');
    else setselectForm(val);
  };
  const _changeCurrStep = (val: any) => {
    setCurrentStep(val);
  };
  const confirmClose = async (closeApp: () => void) => {
    const textMessage =
      'This application will be displayed under Draft Applications tab. Are you sure do you want to go back?';

    //@ts-ignore
    const result = await SwalWithBootstrapButtons.fire({
      icon: 'error',
      title: 'Confirm close',
      text: textMessage,
      allowOutsideClick: false,
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'Cancel',
    });

    if (result.isConfirmed) {
      closeApp && closeApp();
    }
  };
  const onActiveStepChange = () => {
    if (
      currentStep === 0 ||
      (USER_LEVEL.owner.includes(whoAmI) && currentStep === 1)
    ) {
      if (selectForm === 'RENEW_WORK_PERMIT' && state?.from === 'renew') {
        confirmClose(() => {
          // setMainStep(0);
          // if (whoAmI === 'prospective_employee' && clicked) {
          //   setClicked('');
          // }
          navigate(-1);
        });
      } else {
        if (providerApplicationNo) {
          navigate(-1);
        }
        setMainStep(0);
        if (whoAmI === 'prospective_employee' && clicked) {
          setClicked('');
        }
      }
    } else if (spinner?.status !== 'success') {
      setCurrentStep(currentStep - 1);
    }
  };

  const _renderCsmeForm = () => {
    if (initialData?.status === 'MISSING_INFORMATION') {
      return (
        <CsmeComp
          fontScale={fontScale}
          updateFontScale={updateFontScale}
          csmeLabel={csmeFormData?.csmeLabel}
          csmeFormData={csmeFormData}
          acknowledgement={acknowledgement}
          _initialData={initialData}
          stepChange={changeStep}
          touchedStatus={touched}
          _changeTouchStatus={(val: any) => setTouched({ ...val })}
          _changeCurrStep={(val: any) => _changeCurrStep(val)}
          onPayClick={onPayClick}
          currentStep={currentStep}
          onFormSubmit={onFormSubmit}
          onAcknowledgement={onResubmitApplicant}
          onCloseClick={onCloseClick}
          onGoBack={onGoBack}
          whoami={whoAmI}
          onNewCsmeNext={_onNewWorkPermitNext}
          spinner={spinner}
          applicationNo={applicationNo}
          // onDraftSave={_onCSMEDraftSave}
          draftData={draftData}
          onUserDetailsSubmit={onUserDetailsSubmit}
          rightBlockContent={staticPageContentConfig?.rightBlockContent}
          type={selectForm}
          citydata={citydata}
        />
      );
    }
    return (
      <>
        <CsmeComp
          fontScale={fontScale}
          updateFontScale={updateFontScale}
          csmeLabel={csmeFormData?.csmeLabel}
          csmeFormData={csmeFormData}
          acknowledgement={acknowledgement}
          _initialData={initialData}
          stepChange={changeStep}
          touchedStatus={touched}
          _changeTouchStatus={(val: any) => setTouched({ ...val })}
          _changeCurrStep={(val: any) => _changeCurrStep(val)}
          onPayClick={onPayClick}
          currentStep={currentStep}
          onFormSubmit={onFormSubmit}
          onAcknowledgement={onCSMESubmit}
          onCloseClick={onCloseClick}
          onGoBack={onGoBack}
          whoami={whoAmI}
          onNewCsmeNext={_onNewWorkPermitNext}
          spinner={spinner}
          applicationNo={applicationNo}
          onDraftSave={_onCSMEDraftSave}
          draftData={draftData}
          onUserDetailsSubmit={onUserDetailsSubmit}
          rightBlockContent={staticPageContentConfig?.rightBlockContent}
          type={selectForm}
          citydata={citydata}
        />
      </>
    );
  };

  const _renderCsmeVerificationForm = () => {
    if (initialData?.status === 'MISSING_INFORMATION') {
      return (
        <CsmeComp
          fontScale={fontScale}
          updateFontScale={updateFontScale}
          csmeLabel={csmeVerificationFormData?.csmeVerificationLabel}
          csmeFormData={csmeVerificationFormData}
          acknowledgement={acknowledgement}
          _initialData={initialData}
          stepChange={changeStep}
          touchedStatus={touched}
          _changeTouchStatus={(val: any) => setTouched({ ...val })}
          _changeCurrStep={(val: any) => _changeCurrStep(val)}
          onPayClick={onPayClick}
          currentStep={currentStep}
          onFormSubmit={onFormSubmit}
          onAcknowledgement={onResubmitApplicant}
          onCloseClick={onCloseClick}
          onGoBack={onGoBack}
          whoami={whoAmI}
          onNewCsmeNext={_onNewWorkPermitNext}
          spinner={spinner}
          applicationNo={applicationNo}
          // onDraftSave={_onCSMEDraftSave}
          draftData={draftData}
          onUserDetailsSubmit={onUserDetailsSubmit}
          rightBlockContent={staticPageContentConfig?.rightBlockContent}
          type={selectForm}
          citydata={citydata}
        />
      );
    }
    return (
      <>
        <CsmeComp
          fontScale={fontScale}
          updateFontScale={updateFontScale}
          csmeLabel={csmeVerificationFormData?.csmeVerificationLabel}
          csmeFormData={csmeVerificationFormData}
          acknowledgement={acknowledgement}
          _initialData={initialData}
          stepChange={changeStep}
          touchedStatus={touched}
          _changeTouchStatus={(val: any) => setTouched({ ...val })}
          _changeCurrStep={(val: any) => _changeCurrStep(val)}
          onPayClick={onPayClick}
          currentStep={currentStep}
          onFormSubmit={onFormSubmit}
          onAcknowledgement={onCSMESubmit}
          onCloseClick={onCloseClick}
          onGoBack={onGoBack}
          whoami={whoAmI}
          onNewCsmeNext={_onNewWorkPermitNext}
          spinner={spinner}
          applicationNo={applicationNo}
          onDraftSave={_onCSMEDraftSave}
          draftData={draftData}
          onUserDetailsSubmit={onUserDetailsSubmit}
          rightBlockContent={staticPageContentConfig?.rightBlockContent}
          type={selectForm}
          citydata={citydata}
        />
      </>
    );
  };

  const _renderRightEstablishmentForm = () => {
    return (
      <>
        <RightEstablishmentForm
          fontScale={fontScale}
          updateFontScale={updateFontScale}
          compData={rightEstablishmentContent}
          currentStep={currentStep}
          whoami={whoAmI}
          _initialData={initialData}
          acknowledgement={acknowledgement}
          onFormSubmit={onFormSubmit}
          type={selectForm}
          draftData={draftData}
          _changeTouchStatus={(val: any) => setTouched({ ...val })}
          _changeCurrStep={(val: any) => _changeCurrStep(val)}
          stepChange={changeStep}
          applicationNo={applicationNo}
          //onPayClick={onPayClick}
          //onDraftSave={_onCSMEDraftSave}
          //onAcknowledgement={onCSMESubmit}
        />
      </>
    );
  };

  const _renderRightEstablishmentEmployerForm = () => {
    return (
      <>
        <RightEstablishmentEmployerForm
          compData={rightEstablishmentContent}
          fontScale={fontScale}
          updateFontScale={updateFontScale}
          acknowledgement={acknowledgement}
          // type={selectForm}
          marriageLabel={rightEstablishmentContent?.formLabel}
          _initialData={initialData}
          stepChange={changeStep}
          touchedStatus={touched}
          _changeTouchStatus={(val: any) => setTouched({ ...val })}
          _changeCurrStep={(val: any) => _changeCurrStep(val)}
          onPayClick={onPayClick}
          currentStep={currentStep}
          onFormSubmit={onFormSubmit}
          onAcknowledgement={onROEemployerSubmit}
          onCloseClick={onCloseClick}
          onGoBack={onGoBack}
          whoami={whoAmI}
          // onNewCsmeNext={_onNewWorkPermitNext}
          spinner={spinner}
          applicationNo={applicationNo}
          onDraftSave={_onCSMEDraftSave}
          draftData={draftData}
          onUserDetailsSubmit={onUserDetailsSubmit}
          rightBlockContent={staticPageContentConfig?.rightBlockContent}
        />
      </>
    );
  };

  const _renderApplicantSelectComp = () => {
    if (
      !getTypeOfApplicationPageState?.event?.data?.value?.appCardList ||
      getTypeOfApplicationPageState?.event?.data?.value?.appCardList?.length ===
        0
    ) {
      return (
        <StateOSD
          {...(staticPageContentConfig?.loading?.applicationEmpty || {})}
        />
      );
    }
    return (
      <>
        <AppCardListComp
          {...getTypeOfApplicationPageState?.event?.data?.value}
          onCardClick={onApplicantSelectChange}
        />
      </>
    );
  };
  const onAddNewUser = (data: any) => {
    if (showModal) {
      setShowModal(false);
    }
    inviteUserSend('START', {
      payload: data,
    });
  };
  const _addNewUser = () => {
    if (showModal) {
      return (
        // <NewUserModal
        //   showModal={showModal}
        //   onAcknowledgement={onAddNewUser}
        //   onDeny={onModalClose}
        // />
        <TweetyModal
          show={true}
          size={'lg'}
          scrollable={false}
          backdrop={'static'}
          submitButtonTitle={'Invite'}
          onSubmit={onAddNewUser}
          onHide={() => setShowModal(false)}
          title={'Add Employee'}
          tweetyWidgetProps={{
            fields: staticPageContentConfig?.newUser?.FIELDS,
            layout: staticPageContentConfig?.newUser?.layout,
          }}
        />
      );
    }
  };

  const onPayClick = () => {
    const applicationNo =
      newApplicationPageState?.event?.data?.value?.applicationNo ??
      saveApplicantAppPageState?.event?.data?.value?.applicationNo ??
      roeworkPermitDraftPageState?.event?.data?.value?.applicationNo;
    const __status =
      newApplicationPageState?.event?.data?.value?.status ??
      saveApplicantAppPageState?.event?.data?.value?.status ??
      roeworkPermitDraftPageState?.event?.data?.value?.status;
    storageService.set(
      'payableApplications',
      [
        {
          id: applicationNo,
          status: __status,
        },
      ],
      'session'
    );
    props?.onPaymentClick && props?.onPaymentClick();
  };
  const onRefresh = () => {
    navigate('/missing-info');
  };
  // useEffect(() =>
  //   console.log('roe***--->jramworkPermitA-->states', currentStep)
  // );
  const _renderLoading = () => {
    if (
      !implicitSave &&
      (saveApplicantAppPageState?.matches('INITIATE_SAVE_APPLICANT_APP') ||
        workPermitDraftPageState?.matches(
          'INITIATE_CREATE_DRAFT_APPLICATION'
        ) ||
        roeworkPermitDraftPageState?.matches(
          'INITIATE_CREATE_DRAFT_ROE_APPLICATION'
        ))
    ) {
      return (
        <Loader
          useModalLoader={true}
          {...(staticPageContentConfig?.loading?.saveApplication || {})}
        />
      );
    }
    return <></>;
  };

  console.log('testing->stepper', currentStep);
  console.log('continue->', employeeAppliesApplicant);
  console.log('proceed->', proceedToInvite);

  console.log(
    'mast->',
    workPermitDraftPageState.matches('CREATE_DRAFT_APPLICATION_SUCCESS'),
    workPermitDraftPageState?.event?.data?.value,
    applicationNo
  );
  const _renderBody = () => {
    if (newApplicationPageState.matches('INITIATE_CREATE_APPLICATION')) {
      return (
        <Loader
          {...(staticPageContentConfig?.loading?.resubmitApplication || {})}
        />
      );
    }
    if (
      newApplicationPageState.matches('CREATE_APPLICATION_SUCCESS') &&
      newApplicationPageState?.event?.data?.value
    ) {
      if (
        applicationNo !==
        newApplicationPageState?.event?.data?.value?.applicationNo
      )
        setApplicationNo(
          newApplicationPageState?.event?.data?.value?.applicationNo
        );
      if (spinner?.show) {
        console.log('jeyaram-->1step');
        setCurrentStep(currentStep + 1);
        setSpinner({
          show: false,
          status: 'success',
        });
      }
    } else if (
      saveApplicantAppPageState.matches('SAVE_APPLICANT_APP_SUCCESS') &&
      saveApplicantAppPageState?.event?.data?.value
    ) {
      if (
        applicationNo !==
        saveApplicantAppPageState?.event?.data?.value?.applicationNo
      )
        setApplicationNo(
          saveApplicantAppPageState?.event?.data?.value?.applicationNo
        );
      if (spinner?.show) {
        console.log('jeyaram-->2step');

        setCurrentStep(currentStep + 1);
        setSpinner({
          show: false,
          status: 'success',
        });
      }
    } else if (
      workPermitDraftPageState.matches('CREATE_DRAFT_APPLICATION_SUCCESS') &&
      workPermitDraftPageState?.event?.data?.value
    ) {
      if (
        applicationNo !==
        workPermitDraftPageState?.event?.data?.value?.applicationNo
      )
        setApplicationNo(
          workPermitDraftPageState?.event?.data?.value?.applicationNo
        );
      if (spinner?.show) {
        // setCurrentStep(currentStep + 1);
        setSpinner({
          show: false,
          status: 'success',
        });
      }
    } else if (
      roeworkPermitDraftPageState.matches(
        'CREATE_DRAFT_ROE_APPLICATION_SUCCESS'
      ) &&
      roeworkPermitDraftPageState?.event?.data?.value
    ) {
      // setCurrentStep(c=>c+1);
      if (
        applicationNo !==
        roeworkPermitDraftPageState?.event?.data?.value?.applicationNo
      )
        setApplicationNo(
          roeworkPermitDraftPageState?.event?.data?.value?.applicationNo
        );
      if (savebtn) {
        setSpinner({
          show: false,
          status: 'success',
        });
      } else if (spinner?.show) {
        // if(currentStep===3)
        setCurrentStep(currentStep + 1);
        setSpinner({
          show: false,
          status: 'success',
        });
      }
    } else if (
      (newApplicationPageState.matches('CREATE_APPLICATION_ERROR') &&
        newApplicationPageState?.event?.data?.value) ||
      (saveApplicantAppPageState.matches('SAVE_APPLICANT_APP_ERROR') &&
        saveApplicantAppPageState?.event?.data?.value) ||
      (roeworkPermitDraftPageState.matches(
        'CREATE_DRAFT_ROE_APPLICATION_ERROR'
      ) &&
        roeworkPermitDraftPageState?.event?.data?.value)
    ) {
      if (spinner?.show) {
        setSpinner({
          show: false,
          status: 'error',
        });
      }
    }
    if (inviteUserState?.matches('INVITE_USER')) {
      return (
        <Loader {...(staticPageContentConfig?.loading?.inviteUser || {})} />
      );
    }
    if (canCreateNewAppState?.matches('CAN_CREATE')) {
      return (
        <Loader
          {...(staticPageContentConfig?.loading?.getAppCanCreate || {})}
        />
      );
    }
    if (getDraftedAppState?.matches('GET_DRAFTED_APP')) {
      return (
        <Loader {...(staticPageContentConfig?.loading?.getApplication || {})} />
      );
    }
    if (getDraftedAppState?.matches('GET_DRAFTED_DOC')) {
      return (
        <Loader {...(staticPageContentConfig?.loading?.getDocuments || {})} />
      );
    }
    if (getTypeOfApplicationPageState?.matches('GET_TYPE_OF_APPLICATION')) {
      return (
        <Loader
          {...(staticPageContentConfig?.loading?.loadingApplications || {})}
        />
      );
    }
    if (
      resubmitApplicationPageState?.matches('INITIATE_RESUBMIT_APPLICATION')
    ) {
      return (
        <Loader
          {...(staticPageContentConfig?.loading?.resubmitApplication || {})}
        />
      );
    }
    if (resubmitApplicationPageState?.matches('RESUBMIT_APPLICATION_SUCCESS')) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.notifications?.resubmittedSuccess ||
            {})}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
    if (resubmitApplicationPageState?.matches('RESUBMIT_APPLICATION_ERROR')) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.error?.resubmittedFailure || {})}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
    if (
      resubmitApplicationByApplicantPageState?.matches(
        'INITIATE_RESUBMIT_APPLICATION_BY_APPLICANT'
      )
    ) {
      return (
        <Loader
          {...(staticPageContentConfig?.loading?.resubmitApplication || {})}
        />
      );
    }
    if (
      resubmitApplicationByApplicantPageState?.matches(
        'RESUBMIT_APPLICATION_BY_APPLICANT_SUCCESS'
      )
    ) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.notifications?.resubmittedSuccess ||
            {})}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
    if (
      resubmitApplicationByApplicantPageState?.matches(
        'RESUBMIT_APPLICATION_BY_APPLICANT_ERROR'
      )
    ) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.error?.resubmittedFailure || {})}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
    // if (
    //   newApplicationPageState.matches('INITIATE_CREATE_APPLICATION')  ||
    //   saveApplicantAppPageState.matches('INITIATE_SAVE_APPLICANT_APP')
    // ) {
    //   if (!spinner?.show) {
    //     setSpinner({
    //       show: true,
    //       status: 'loading',
    //     });
    //   }
    // }

    if (whoAmI === 'prospective_employee' && !clicked) {
      return _renderApplicantSelectComp();
    }

    if (mainStep === 0) {
      return (
        // <div style={{ minHeight: height - height / 3 }}>
        //   <SelectComp
        //     onChange={onChangeForm}
        //     value={selectForm}
        //     whoAmI={whoAmI}
        //     onGoBack={() => {
        //       setClicked('');
        //     }}
        //     isBack={whoAmI === 'prospective_employee'}
        //   />
        // </div>
        <AppCardListComp
          {...applicationCards?.employer}
          onCardClick={onChangeForm}
        />
      );
    }

    if (
      selectForm === 'NEW_WORK_PERMIT' ||
      selectForm === 'CARICOM_NEW_WORK_PERMIT'
    ) {
      const totalSteps = whoAmI === 'prospective_employee' ? 2 : 4;

      const getProgressSteps = () => {
        return workPermitFormData.progressBarSteps!.map(
          (step: any, key: number) => {
            if (key < totalSteps) return workPermitFormData?.workPermitLabel;
            return totalSteps === 2
              ? workPermitFormData.progressBarSteps![key + 2]
              : step;
          }
        );
      };

      const _renderWorkPermit = () => {
        console.log('testingformissinginfo->', initialData, draftData);
        console.log(`workPermitFormData draftData 1`, currentStep);

        // if (currentStep === 3 && USER_LEVEL.owner.includes(whoAmI ?? '')) {
        //   return (
        //     <>
        //       <SelectSubmissionType
        //         rightBlockContent={staticPageContentConfig?.rightBlockContent}
        //         onContinueClick={() => {
        //           setemployeeAppliesApplicant(true);
        //           setproceedToInvite(false);
        //           setCurrentStep(currentStep + 1);
        //         }}
        //         onProceedToInvite={() => {
        //           setproceedToInvite(true);
        //           setemployeeAppliesApplicant(false);
        //           setCurrentStep(currentStep + 1);
        //         }}
        //       />
        //     </>
        //   );
        // }
        if (roe || initialData?.type === 'CARICOM_NEW_WORK_PERMIT') {
          if (initialData?.status === 'MISSING_INFORMATION') {
            return (
              console.log(
                'workPermitFormDataincontainer',
                roeworkPermitFormData
              ),
              (
                <RoeWPForm
                  roeLabel={roeworkPermitFormData?.workPermitLabel}
                  roeFormData={roeworkPermitFormData}
                  acknowledgement={acknowledgement}
                  fontScale={fontScale}
                  updateFontScale={updateFontScale}
                  _initialData={initialData}
                  stepChange={changeStep}
                  touchedStatus={touched}
                  _changeTouchStatus={(val: any) => setTouched({ ...val })}
                  _changeCurrStep={(val: any) => _changeCurrStep(val)}
                  onPayClick={onPayClick}
                  currentStep={currentStep}
                  onFormSubmit={onFormSubmit}
                  onAcknowledgement={onResubmitApp}
                  onCloseClick={onCloseClick}
                  onGoBack={onGoBack}
                  whoami={whoAmI}
                  rendersave={true}
                  // onNewroeNext={onRoeWorkPermitNext}
                  spinner={spinner}
                  applicationNo={applicationNo}
                  draftData={draftData}
                  onUserDetailsSubmit={onUserDetailsSubmit}
                  rightBlockContent={staticPageContentConfig?.rightBlockContent}
                  type={selectForm}
                  employeeAppliesApplicant={employeeAppliesApplicant}
                  proceedInvite={proceedToInvite}
                  setEmployeeApplies={(val) => {
                    setproceedToInvite(false);
                    setemployeeAppliesApplicant(val);
                  }}
                  setProceedToInvite={(val) => {
                    setemployeeAppliesApplicant(false);
                    setproceedToInvite(val);
                  }}
                  onContinueClick={() => {
                    setemployeeAppliesApplicant(true);
                    setproceedToInvite(false);
                    setCurrentStep(3);
                  }}
                  onProceedToInvite={() => {
                    setproceedToInvite(true);
                    setemployeeAppliesApplicant(false);
                    setCurrentStep(3);
                  }}
                />
              )
            );
          }
          return (
            console.log('workPermitFormDataincontainer', roeworkPermitFormData),
            (
              <RoeWPForm
                roeLabel={roeworkPermitFormData?.workPermitLabel}
                roeFormData={roeworkPermitFormData}
                acknowledgement={acknowledgement}
                fontScale={fontScale}
                updateFontScale={updateFontScale}
                _initialData={initialData}
                stepChange={changeStep}
                touchedStatus={touched}
                _changeTouchStatus={(val: any) => setTouched({ ...val })}
                _changeCurrStep={(val: any) => _changeCurrStep(val)}
                onPayClick={onPayClick}
                currentStep={currentStep}
                onFormSubmit={onFormSubmit}
                onAcknowledgement={onRoeWorkPermitSubmit}
                onCloseClick={onCloseClick}
                onGoBack={onGoBack}
                whoami={whoAmI}
                onNewroeNext={onRoeWorkPermitNext}
                spinner={spinner}
                applicationNo={applicationNo}
                onDraftSave={onRoeWorkPermitNext}
                draftData={draftData}
                onUserDetailsSubmit={onUserDetailsSubmit}
                rightBlockContent={staticPageContentConfig?.rightBlockContent}
                type={selectForm}
                employeeAppliesApplicant={employeeAppliesApplicant}
                proceedInvite={proceedToInvite}
                setEmployeeApplies={(val) => {
                  setproceedToInvite(false);
                  setemployeeAppliesApplicant(val);
                }}
                setProceedToInvite={(val) => {
                  setemployeeAppliesApplicant(false);
                  setproceedToInvite(val);
                }}
                onContinueClick={() => {
                  setemployeeAppliesApplicant(true);
                  setproceedToInvite(false);
                  setCurrentStep(3);
                }}
                onProceedToInvite={() => {
                  setproceedToInvite(true);
                  setemployeeAppliesApplicant(false);
                  setCurrentStep(3);
                }}
              />
            )
          );
        }
        if (initialData?.status === 'MISSING_INFORMATION') {
          return (
            <WorkPermitComp
              fontScale={fontScale}
              updateFontScale={updateFontScale}
              workPermitLabel={resubmitFormData?.workPermitLabel}
              workPermitFormData={workPermitFormData}
              acknowledgement={acknowledgement}
              _initialData={initialData}
              stepChange={changeStep}
              employeeAppliesApplicant={employeeAppliesApplicant}
              proceedInvite={proceedToInvite}
              setEmployeeApplies={(val) => {
                setproceedToInvite(false);
                setemployeeAppliesApplicant(val);
              }}
              setProceedToInvite={(val) => {
                setemployeeAppliesApplicant(false);
                setproceedToInvite(val);
              }}
              rendersave={true}
              touchedStatus={touched}
              citydata={citydata}
              _stepHasError={stepHasError}
              changeStepHasError={(val: any) => setStepHasError({ ...val })}
              _changeTouchStatus={(val: any) => setTouched({ ...val })}
              _changeCurrStep={(val: any) => _changeCurrStep(val)}
              onPayClick={onPayClick}
              currentStep={currentStep}
              // setCurrentStep={setCurrentStep}
              onFormSubmit={onFormSubmit}
              onAcknowledgement={onResubmitApp}
              onCloseClick={onCloseClick}
              onGoBack={onGoBack}
              whoami={whoAmI}
              // onNewWorkPermitNext={_onNewWorkPermitNext}
              spinner={spinner}
              // onDraftSave={_onDraftSave}
              // draftData={draftData}
              onUserDetailsSubmit={onUserDetailsSubmit}
              rightBlockContent={staticPageContentConfig?.rightBlockContent}
              //onParishChange={_onParishChange}
              applicationNo={applicationNo}
              onContinueClick={() => {
                setemployeeAppliesApplicant(true);
                setproceedToInvite(false);
                setCurrentStep(currentStep + 1);
              }}
              onProceedToInvite={() => {
                setproceedToInvite(true);
                setemployeeAppliesApplicant(false);
                setCurrentStep(currentStep + 1);
              }}
            />
          );
        }
        // toast.success('missing info app found!!!');
        return (
          <WorkPermitComp
            workPermitLabel={workPermitFormData?.workPermitLabel}
            workPermitFormData={workPermitFormData}
            acknowledgement={acknowledgement}
            _initialData={initialData}
            stepChange={changeStep}
            employeeAppliesApplicant={employeeAppliesApplicant}
            proceedInvite={proceedToInvite}
            fontScale={fontScale}
            updateFontScale={updateFontScale}
            setEmployeeApplies={(val) => {
              setproceedToInvite(false);
              setemployeeAppliesApplicant(val);
            }}
            setProceedToInvite={(val) => {
              setemployeeAppliesApplicant(false);
              setproceedToInvite(val);
            }}
            touchedStatus={touched}
            _stepHasError={stepHasError}
            changeStepHasError={(val: any) => setStepHasError({ ...val })}
            _changeTouchStatus={(val: any) => setTouched({ ...val })}
            _changeCurrStep={(val: any) => _changeCurrStep(val)}
            onPayClick={onPayClick}
            currentStep={currentStep}
            // setCurrentStep={setCurrentStep}
            onFormSubmit={onFormSubmit}
            onAcknowledgement={onWorkPermitSubmit}
            onCloseClick={onCloseClick}
            onGoBack={onGoBack}
            whoami={whoAmI}
            onNewWorkPermitNext={_onNewWorkPermitNext}
            spinner={spinner}
            citydata={citydata}
            onDraftSave={_onDraftSave}
            draftData={draftData}
            onUserDetailsSubmit={onUserDetailsSubmit}
            rightBlockContent={staticPageContentConfig?.rightBlockContent}
            //onParishChange={_onParishChange}
            applicationNo={applicationNo}
            onContinueClick={() => {
              setemployeeAppliesApplicant(true);
              setproceedToInvite(false);
              setCurrentStep(currentStep + 1);
            }}
            onProceedToInvite={() => {
              setproceedToInvite(true);
              setemployeeAppliesApplicant(false);
              setCurrentStep(currentStep + 1);
            }}
          />
        );
      };

      return (
        <>
          <ProgressBar
            onActiveStepChange={onActiveStepChange}
            activeStep={
              USER_LEVEL.owner.includes(whoAmI ?? '')
                ? currentStep - 1
                : currentStep
            }
            totalSteps={
              USER_LEVEL.owner.includes(whoAmI ?? '')
                ? (employeeAppliesApplicant ? 1 : 0) + 3
                : // 4
                  2
            }
            onCloseClick={onCloseClick}
            progressBarSteps={getProgressSteps()}
            isGoBackDisabled={
              spinner.status === 'success'
              //|| mainStep === 1
            }
          />
          {_renderWorkPermit()}
        </>
      );
    } else if (
      selectForm === 'RENEW_WORK_PERMIT' ||
      selectForm === 'CARICOM_RENEW_WORK_PERMIT'
    ) {
      console.log(
        `APPLICATION_INCOMPLETE ::`,
        applicationNo && applicationNo?.startsWith('RWP')
      );
      if (!applicationNo && applicationNo?.startsWith('RWP')) {
        navigate('/work-permits');
      }
      const totalSteps = whoAmI === 'prospective_employee' ? 2 : 4;
      // navigate('/work-permits');
      const getProgressSteps = () => {
        return renewWorkPermitFormData.progressBarSteps!.map(
          (step: any, key: number) => {
            if (key < totalSteps)
              return renewWorkPermitFormData?.workPermitRenewalLabel;
            return totalSteps === 2
              ? renewWorkPermitFormData.progressBarSteps![key + 2]
              : step;
          }
        );
      };
      const _renderRenewWorkPermit = () => {
        console.log('comingtorenew->', initialData);
        console.log(
          'comingtorenew->',
          `${initialData?.firstName} ${initialData?.lastName}`
        );
        console.log('comingtorenew->', initialData?.userEmail);
        if (roe || initialData?.type === 'CARICOM_RENEW_WORK_PERMIT') {
          return (
            console.log('workPermitFormDataincontainer', roeworkPermitFormData),
            (
              <RoeRWPForm
                roeLabel={roeworkPermitFormData?.workPermitRenewalLabel}
                roeFormData={roeworkPermitFormData}
                fontScale={fontScale}
                updateFontScale={updateFontScale}
                acknowledgement={acknowledgement}
                _initialData={initialData}
                stepChange={changeStep}
                touchedStatus={touched}
                _changeTouchStatus={(val: any) => setTouched({ ...val })}
                _changeCurrStep={(val: any) => _changeCurrStep(val)}
                onPayClick={onPayClick}
                currentStep={currentStep}
                onFormSubmit={onFormSubmit}
                onAcknowledgement={onRoeWorkPermitSubmit}
                onCloseClick={onCloseClick}
                onGoBack={onGoBack}
                whoami={whoAmI}
                onNewroeNext={onRoeWorkPermitNext}
                spinner={spinner}
                applicationNo={applicationNo}
                onDraftSave={onRoeWorkPermitNext}
                draftData={draftData}
                onUserDetailsSubmit={onUserDetailsSubmit}
                rightBlockContent={staticPageContentConfig?.rightBlockContent}
                type={selectForm}
                employeeAppliesApplicant={employeeAppliesApplicant}
                proceedInvite={proceedToInvite}
                setEmployeeApplies={(val) => {
                  setproceedToInvite(false);
                  setemployeeAppliesApplicant(val);
                }}
                setProceedToInvite={(val) => {
                  setemployeeAppliesApplicant(false);
                  setproceedToInvite(val);
                }}
                onContinueClick={() => {
                  setemployeeAppliesApplicant(true);
                  setproceedToInvite(false);
                  setCurrentStep(3);
                }}
                onProceedToInvite={() => {
                  setproceedToInvite(true);
                  setemployeeAppliesApplicant(false);
                  setCurrentStep(3);
                }}
              />
            )
          );
        }
        if (initialData?.status === 'MISSING_INFORMATION') {
          return (
            <div style={{ border: '2px solid red' }}>
              <RenewWorkPermitComp
                fontScale={fontScale}
                updateFontScale={updateFontScale}
                workPermitLabel={resubmitFormData?.workPermitRenewalLabel}
                workPermitFormData={renewWorkPermitFormData}
                acknowledgement={acknowledgement}
                _initialData={initialData}
                stepChange={changeStep}
                employeeAppliesApplicant={employeeAppliesApplicant}
                proceedInvite={proceedToInvite}
                setEmployeeApplies={(val) => {
                  setproceedToInvite(false);
                  setemployeeAppliesApplicant(val);
                }}
                setProceedToInvite={(val) => {
                  setemployeeAppliesApplicant(false);
                  setproceedToInvite(val);
                }}
                citydata={citydata}
                _stepHasError={stepHasError}
                changeStepHasError={(val: any) => setStepHasError({ ...val })}
                rendersave={true}
                touchedStatus={touched}
                _changeTouchStatus={(val: any) => setTouched({ ...val })}
                _changeCurrStep={(val: any) => _changeCurrStep(val)}
                // onPayClick={onPayClick}
                currentStep={currentStep}
                onFormSubmit={onFormSubmit}
                onAcknowledgement={onResubmitApp}
                onCloseClick={onCloseClick}
                whoami={whoAmI}
                // onNewWorkPermitNext={_onNewWorkPermitNext}
                spinner={spinner}
                // onDraftSave={_onDraftSave}
                // draftData={draftData}
                onUserDetailsSubmit={onUserDetailsSubmit}
                rightBlockContent={staticPageContentConfig?.rightBlockContent}
                applicationNo={applicationNo}
                onContinueClick={() => {
                  setemployeeAppliesApplicant(true);
                  setproceedToInvite(false);
                  setCurrentStep(currentStep + 1);
                }}
                onProceedToInvite={() => {
                  setproceedToInvite(true);
                  setemployeeAppliesApplicant(false);
                  setCurrentStep(currentStep + 1);
                }}
              />
            </div>
          );
        }
        return (
          <RenewWorkPermitComp
            fontScale={fontScale}
            updateFontScale={updateFontScale}
            workPermitLabel={renewWorkPermitFormData?.workPermitRenewalLabel}
            workPermitFormData={renewWorkPermitFormData}
            acknowledgement={acknowledgement}
            _initialData={initialData}
            stepChange={changeStep}
            employeeAppliesApplicant={employeeAppliesApplicant}
            proceedInvite={proceedToInvite}
            setEmployeeApplies={(val) => {
              setproceedToInvite(false);
              setemployeeAppliesApplicant(val);
            }}
            setProceedToInvite={(val) => {
              setemployeeAppliesApplicant(false);
              setproceedToInvite(val);
            }}
            citydata={citydata}
            touchedStatus={touched}
            _stepHasError={stepHasError}
            changeStepHasError={(val: any) => setStepHasError({ ...val })}
            _changeTouchStatus={(val: any) => setTouched({ ...val })}
            _changeCurrStep={(val: any) => _changeCurrStep(val)}
            onPayClick={onPayClick}
            currentStep={currentStep}
            onFormSubmit={onFormSubmit}
            onAcknowledgement={onWorkPermitSubmit}
            onCloseClick={onCloseClick}
            whoami={whoAmI}
            onNewWorkPermitNext={_onNewWorkPermitNext}
            spinner={spinner}
            onDraftSave={_onDraftSave}
            draftData={draftData}
            onUserDetailsSubmit={onUserDetailsSubmit}
            rightBlockContent={staticPageContentConfig?.rightBlockContent}
            applicationNo={applicationNo}
            onContinueClick={() => {
              setemployeeAppliesApplicant(true);
              setproceedToInvite(false);
              setCurrentStep(currentStep + 1);
            }}
            onProceedToInvite={() => {
              setproceedToInvite(true);
              setemployeeAppliesApplicant(false);
              setCurrentStep(currentStep + 1);
            }}
          />
        );
      };
      //
      return (
        <>
          <ProgressBar
            onActiveStepChange={onActiveStepChange}
            activeStep={
              USER_LEVEL.owner.includes(whoAmI) ? currentStep - 1 : currentStep
            }
            totalSteps={
              USER_LEVEL.owner.includes(whoAmI)
                ? (employeeAppliesApplicant ? 1 : 0) + 3
                : // 4
                  2
            }
            onCloseClick={onCloseClick}
            progressBarSteps={getProgressSteps()}
            isGoBackDisabled={
              spinner.status === 'success'
              //|| mainStep === 1
            }
          />
          {_renderRenewWorkPermit()}
          {/* {renderError()} */}
          {/*  */}
        </>
      );
    } else if (selectForm === 'workPermitAppeal') {
      return (
        <>
          <WorkPermitComp
            whoami={whoAmI}
            fontScale={fontScale}
            workPermitFormData={workPermitFormData}
            acknowledgement={acknowledgement}
            workPermitLabel={workPermitFormData?.workPermitAppealLabel}
            onAcknowledgement={onWorkPermitSubmit}
            onCloseClick={onCloseClick}
            onGoBack={onGoBack}
          />
        </>
      );
    } else if (selectForm === 'RENEW_CSME_CERTIFICATE') {
      const totalSteps = 2;
      const _renderRenewCsmeForm = () => {
        return (
          <>
            <RenewCsmeComp
              csmeLabel={renewCsmeFormData?.csmeRenewalLabel}
              renewCsmeFormData={renewCsmeFormData}
              fontScale={fontScale}
              updateFontScale={updateFontScale}
              acknowledgement={acknowledgement}
              _initialData={initialData}
              stepChange={changeStep}
              touchedStatus={touched}
              _changeTouchStatus={(val: any) => setTouched({ ...val })}
              _changeCurrStep={(val: any) => _changeCurrStep(val)}
              onPayClick={onPayClick}
              currentStep={currentStep}
              onFormSubmit={onFormSubmit}
              onAcknowledgement={onCSMESubmit}
              onCloseClick={onCloseClick}
              onGoBack={onGoBack}
              whoami={whoAmI}
              onNewCsmeNext={_onNewWorkPermitNext}
              spinner={spinner}
              applicationNo={applicationNo}
              onDraftSave={_onCSMEDraftSave}
              draftData={draftData}
              onUserDetailsSubmit={onUserDetailsSubmit}
              rightBlockContent={staticPageContentConfig?.rightBlockContent}
              type={selectForm}
            />
          </>
        );
      };
      const getProgressSteps = () => {
        return renewCsmeFormData?.progressBarSteps!.map(
          (step: any, key: number) => {
            if (key < totalSteps) return renewCsmeFormData?.workPermitLabel;
            return totalSteps === 2
              ? renewCsmeFormData?.progressBarSteps![key + 2]
              : step;
          }
        );
      };

      return (
        <>
          <ProgressBar
            onActiveStepChange={onActiveStepChange}
            activeStep={currentStep}
            totalSteps={2}
            onCloseClick={onCloseClick}
            progressBarSteps={getProgressSteps()}
            // isGoBackDisabled={mainStep === 1}
          />
          {_renderRenewCsmeForm()}
        </>
      );
    } else if (selectForm === 'NEW_CSME_CERTIFICATE') {
      const totalSteps = 2;

      const getProgressSteps = () => {
        return csmeFormData.progressBarSteps!.map((step: any, key: number) => {
          if (key < totalSteps) return csmeFormData?.csmeLabel;
          return totalSteps === 2
            ? csmeFormData.progressBarSteps![key + 2]
            : step;
        });
      };

      return (
        <>
          <ProgressBar
            onActiveStepChange={onActiveStepChange}
            activeStep={currentStep}
            totalSteps={2}
            onCloseClick={onCloseClick}
            progressBarSteps={getProgressSteps()}
            // isGoBackDisabled={!!providerApplicationNo}
          />
          {_renderCsmeForm()}
        </>
      );
    } else if (selectForm === 'CSME_VERIFICATION') {
      const totalSteps = 2;
      const getProgressSteps = () => {
        return csmeVerificationFormData.progressBarSteps!.map(
          (step: any, key: number) => {
            if (key < totalSteps)
              return csmeVerificationFormData?.workPermitLabel;
            return totalSteps === 2
              ? csmeVerificationFormData.progressBarSteps![key + 2]
              : step;
          }
        );
      };

      return (
        <>
          <ProgressBar
            onActiveStepChange={onActiveStepChange}
            activeStep={currentStep}
            totalSteps={2}
            onCloseClick={onCloseClick}
            progressBarSteps={getProgressSteps()}
            // isGoBackDisabled={mainStep === 1}
          />
          {_renderCsmeVerificationForm()}
        </>
      );
    } else if (selectForm === 'RIGHTS_OF_ESTABLISHMENT') {
      const totalSteps = 2;
      const getProgressSteps = () => {
        return csmeVerificationFormData.progressBarSteps!.map(
          (step: any, key: number) => {
            if (key < totalSteps)
              return csmeVerificationFormData?.workPermitLabel;
            return totalSteps === 2
              ? csmeVerificationFormData.progressBarSteps![key + 2]
              : step;
          }
        );
      };

      return (
        <>
          <ProgressBar
            onActiveStepChange={onActiveStepChange}
            activeStep={currentStep}
            totalSteps={2}
            onCloseClick={onCloseClick}
            progressBarSteps={getProgressSteps()}
            // isGoBackDisabled={mainStep === 1}
          />
          {_renderRightEstablishmentForm()}
        </>
      );
    } else if (selectForm === 'RIGHTS_OF_ESTABLISHMENT_EMPLOYER') {
      const totalSteps = 2;
      const getProgressSteps = () => {
        return csmeVerificationFormData.progressBarSteps!.map(
          (step: any, key: number) => {
            if (key < totalSteps)
              return csmeVerificationFormData?.workPermitLabel;
            return totalSteps === 2
              ? csmeVerificationFormData.progressBarSteps![key + 2]
              : step;
          }
        );
      };

      return (
        <>
          <ProgressBar
            onActiveStepChange={onActiveStepChange}
            activeStep={currentStep}
            totalSteps={2}
            onCloseClick={onCloseClick}
            progressBarSteps={getProgressSteps()}
            // isGoBackDisabled={mainStep === 1}
          />
          {_renderRightEstablishmentEmployerForm()}
        </>
      );
    }
    if (selectForm === 'MARRIAGE_EXEMPTION') {
      const totalSteps = 2;
      console.log('imcomingforyou->init', initialData);
      const _renderMarriageExmpForm = () => {
        if (initialData?.status === 'MISSING_INFORMATION') {
          return (
            <>
              <MarriageExemptionComp
                marriageLabel={marriageExemptionFormData?.marriageExmpLabel}
                marriageExemFormData={marriageExemptionFormData}
                fontScale={fontScale}
                updateFontScale={updateFontScale}
                acknowledgement={acknowledgement}
                _initialData={initialData}
                stepChange={changeStep}
                touchedStatus={touched}
                _changeTouchStatus={(val: any) => setTouched({ ...val })}
                _changeCurrStep={(val: any) => _changeCurrStep(val)}
                onPayClick={onPayClick}
                currentStep={currentStep}
                onFormSubmit={onFormSubmit}
                onAcknowledgement={onResubmitApplicant}
                onCloseClick={onCloseClick}
                onGoBack={onGoBack}
                whoami={whoAmI}
                rendersave={true}
                // onNewCsmeNext={_onNewWorkPermitNext}
                spinner={spinner}
                applicationNo={applicationNo}
                citydata={citydata}
                // onDraftSave={_onCSMEDraftSave}
                draftData={draftData}
                onUserDetailsSubmit={onUserDetailsSubmit}
                rightBlockContent={staticPageContentConfig?.rightBlockContent}
              />
            </>
          );
        }
        return (
          <>
            <MarriageExemptionComp
              marriageLabel={marriageExemptionFormData?.marriageExmpLabel}
              marriageExemFormData={marriageExemptionFormData}
              fontScale={fontScale}
              updateFontScale={updateFontScale}
              acknowledgement={acknowledgement}
              _initialData={initialData}
              stepChange={changeStep}
              touchedStatus={touched}
              _changeTouchStatus={(val: any) => setTouched({ ...val })}
              _changeCurrStep={(val: any) => _changeCurrStep(val)}
              onPayClick={onPayClick}
              currentStep={currentStep}
              onFormSubmit={onFormSubmit}
              onAcknowledgement={onMarriageExemSubmit}
              onCloseClick={onCloseClick}
              onGoBack={onGoBack}
              whoami={whoAmI}
              citydata={citydata}
              // onNewCsmeNext={_onNewWorkPermitNext}
              spinner={spinner}
              applicationNo={applicationNo}
              onDraftSave={_onCSMEDraftSave}
              draftData={draftData}
              onUserDetailsSubmit={onUserDetailsSubmit}
              rightBlockContent={staticPageContentConfig?.rightBlockContent}
            />
          </>
        );
      };
      const getProgressSteps = () => {
        return marriageExemptionFormData.progressBarSteps!.map(
          (step: any, key: number) => {
            if (key < totalSteps) return csmeFormData?.workPermitLabel;
            return totalSteps === 2
              ? marriageExemptionFormData.progressBarSteps![key + 2]
              : step;
          }
        );
      };

      return (
        <>
          <ProgressBar
            onActiveStepChange={onActiveStepChange}
            activeStep={currentStep}
            totalSteps={2}
            onCloseClick={onCloseClick}
            progressBarSteps={getProgressSteps()}
            // isGoBackDisabled={mainStep === 1}
          />
          {_renderMarriageExmpForm()}
        </>
      );
    }
    if (selectForm === 'RENEW_MARRIAGE_EXEMPTION') {
      const totalSteps = 2;
      console.log('imcomingforyou->init', initialData);
      const _renderMarriageExmpForm = () => {
        if (initialData?.status === 'MISSING_INFORMATION') {
          return (
            <>
              <RenewMarriageExemptionComp
                marriageLabel={
                  marriageExemptionFormData?.marriageExmpRenewalLabel
                }
                fontScale={fontScale}
                updateFontScale={updateFontScale}
                marriageExemFormData={marriageExemptionFormData}
                acknowledgement={acknowledgement}
                _initialData={initialData}
                stepChange={changeStep}
                touchedStatus={touched}
                _changeTouchStatus={(val: any) => setTouched({ ...val })}
                _changeCurrStep={(val: any) => _changeCurrStep(val)}
                onPayClick={onPayClick}
                currentStep={currentStep}
                onFormSubmit={onFormSubmit}
                onAcknowledgement={onResubmitApplicant}
                onCloseClick={onCloseClick}
                onGoBack={onGoBack}
                whoami={whoAmI}
                citydata={citydata}
                // onNewCsmeNext={_onNewWorkPermitNext}
                spinner={spinner}
                applicationNo={applicationNo}
                onDraftSave={_onCSMEDraftSave}
                rendersave={true}
                draftData={draftData}
                onUserDetailsSubmit={onUserDetailsSubmit}
                rightBlockContent={staticPageContentConfig?.rightBlockContent}
              />
            </>
          );
        }
        return (
          <>
            <RenewMarriageExemptionComp
              marriageLabel={
                marriageExemptionFormData?.marriageExmpRenewalLabel
              }
              fontScale={fontScale}
              updateFontScale={updateFontScale}
              marriageExemFormData={marriageExemptionFormData}
              acknowledgement={acknowledgement}
              _initialData={initialData}
              stepChange={changeStep}
              citydata={citydata}
              touchedStatus={touched}
              _changeTouchStatus={(val: any) => setTouched({ ...val })}
              _changeCurrStep={(val: any) => _changeCurrStep(val)}
              onPayClick={onPayClick}
              currentStep={currentStep}
              onFormSubmit={onFormSubmit}
              onAcknowledgement={onMarriageExemSubmit}
              onCloseClick={onCloseClick}
              onGoBack={onGoBack}
              whoami={whoAmI}
              // onNewCsmeNext={_onNewWorkPermitNext}
              spinner={spinner}
              applicationNo={applicationNo}
              onDraftSave={_onCSMEDraftSave}
              draftData={draftData}
              onUserDetailsSubmit={onUserDetailsSubmit}
              rightBlockContent={staticPageContentConfig?.rightBlockContent}
            />
          </>
        );
      };
      const getProgressSteps = () => {
        return marriageExemptionFormData.progressBarSteps!.map(
          (step: any, key: number) => {
            if (key < totalSteps) return csmeFormData?.workPermitLabel;
            return totalSteps === 2
              ? marriageExemptionFormData.progressBarSteps![key + 2]
              : step;
          }
        );
      };

      return (
        <>
          <ProgressBar
            onActiveStepChange={onActiveStepChange}
            activeStep={currentStep}
            totalSteps={2}
            onCloseClick={onCloseClick}
            progressBarSteps={getProgressSteps()}
            // isGoBackDisabled={mainStep === 1}
          />
          {_renderMarriageExmpForm()}
        </>
      );
    }

    return <></>;
  };

  const _renderHeader = () => {
    if (staticPageContentConfig?.header) {
      let config = {};
      if (selectForm === '' || mainStep === 0) {
        config = staticPageContentConfig?.header?.default;
      } else if (selectForm === 'NEW_WORK_PERMIT') {
        config = staticPageContentConfig?.header?.nwp;
      } else if (selectForm === 'NEW_CSME_CERTIFICATE') {
        config = staticPageContentConfig?.header?.ncsme;
      } else if (selectForm === 'RENEW_WORK_PERMIT') {
        config = staticPageContentConfig?.header?.rwp;
      } else if (selectForm === 'RENEW_CSME_CERTIFICATE') {
        config = staticPageContentConfig?.header?.rcsme;
      } else if (selectForm === 'MARRIAGE_EXEMPTION') {
        config = staticPageContentConfig?.header?.marriageExemption;
      } else if (selectForm === 'RENEW_MARRIAGE_EXEMPTION') {
        config = staticPageContentConfig?.header?.marriageExemption;
      } else if (selectForm === 'CSME_VERIFICATION') {
        config = staticPageContentConfig?.header?.csmev;
      } else if (selectForm === 'RIGHTS_OF_ESTABLISHMENT') {
        config = staticPageContentConfig?.header?.rightsOfEst;
      } else if (selectForm === 'RIGHTS_OF_ESTABLISHMENT_EMPLOYER') {
        config = staticPageContentConfig?.header?.rightsOfEst;
      }
      return (
        <>
          <Header
            {...(config || {})}
            isRWP={mainStep !== 0}
            name={
              initialData?.firstName && initialData?.lastName
                ? `${initialData.firstName} ${initialData.lastName}`
                : initialData?.firstName || initialData?.lastName || null
            }
            email={initialData?.userEmail}
          />
        </>
      );
    }
    return undefined;
  };

  const [orgStatus, setOrgStatus] = useState('');

  useEffect(() => {
    setTimeout(() => {
      const _sessionData = storageService.get('myProfile', 'session');
      if (!orgStatus && _sessionData?.org?.status) {
        setOrgStatus(_sessionData?.org?.status);
      }
    }, 2000);
  });

  const _sessionData = storageService.get('myProfile', 'session');
  const _orgStatus = _sessionData?.org?.status;
  const _tccExpiryDate = _sessionData?.org?.tccExpiryDate;
  if (!orgStatus && _orgStatus) {
    setOrgStatus(_orgStatus);
  }
  const isDateExpired = (dateString: any) => {
    const givenDate = new Date(dateString);
    const today = new Date();
    return givenDate < today;
  };
  const isTCCExpired = _tccExpiryDate ? isDateExpired(_tccExpiryDate) : false;
  console.log(
    'tioi',
    _tccExpiryDate,
    isTCCExpired,
    isDateExpired(_tccExpiryDate)
  );

  const _renderElseBody = () => {
    if (isTCCExpired) {
      // Check if TCC is expired
      return (
        <StateOSD {...(staticPageContentConfig?.loading?.tccExpired || {})} />
      );
    } else if (USER_LEVEL.owner.includes(whoAmI)) {
      return (
        <StateOSD
          {...(staticPageContentConfig?.loading?.notAuthorized || {})}
        />
      );
    } else {
      return (
        <StateOSD
          {...(staticPageContentConfig?.loading?.applicationEmpty || {})}
        />
      );
    }
  };
  return (
    <div>
      {_renderHeader()}
      {(USER_LEVEL.owner.includes(whoAmI) &&
        orgStatus &&
        orgStatus === 'ACCEPTED' &&
        !isTCCExpired) ||
      whoAmI === 'prospective_employee'
        ? _renderBody()
        : _renderElseBody()}
      {_addNewUser()}
      {_renderLoading()}
    </div>
  );
};
